let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5vF82")).then(() => parcelRequire('bKZy2'));